// dailylogSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DailyLog } from '../../features/dailylogs/Dailylogs';

interface DailyLogsState {
  // Define your state properties
  selectedLog: DailyLog | null;
}

const initialState: DailyLogsState = {
  selectedLog: null,
  // other state properties...
};

const dailyLogsSlice = createSlice({
  name: 'dailyLogs',
  initialState,
  reducers: {
    setSelectedLogsuman: (state, action: PayloadAction<DailyLog | null>) => {
      state.selectedLog = action.payload;
    },
    // other reducers...
  },
});

export const { setSelectedLogsuman } = dailyLogsSlice.actions;
export default dailyLogsSlice.reducer;
